import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { hotItems } from "@/mocks/hotContent";

const tags = ["全部", "剧情解析", "设定解析", "角色盘点", "角色解读", "世界观"];

export default function HotContent() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? hotItems : hotItems.filter((item) => item.tag === active)),
    [active],
  );

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        kicker="热门内容"
        title="追更前先读懂这些"
        desc="围绕斗罗大陆漫画的世界观、角色与剧情整理的深度内容，帮你更快进入故事。"
      />

      <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
        {tags.map((tag) => (
          <button
            key={tag}
            type="button"
            onClick={() => setActive(tag)}
            className={`rounded-full px-1 py-1 transition-colors ${
              active === tag ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
            }`}
          >
            <span className="px-3 py-1 text-xs font-medium whitespace-nowrap">{tag}</span>
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                {item.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-time-line" /> 阅读约 {item.readTime}
                </span>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}